import { useState } from "react";

function InputText({
  labelTitle,
  labelStyle,
  name,
  type,
  containerStyle,
  defaultValue,
  placeholder,
  updateFormValue,
  autoComplete,
}: {
  labelTitle: string;
  labelStyle?: string;
  name: string;
  type: string;
  containerStyle: string;
  defaultValue: string;
  placeholder?: string;
  updateFormValue: (input: any) => void;
  autoComplete?: string;
}) {
  const [value, setValue] = useState(defaultValue);

  const updateInputValue = (val: string) => {
    setValue(val);
    updateFormValue({ name, value: val });
  };

  return (
    <div className={`form-control w-full ${containerStyle}`}>
      <label className="label">
        <span className={"label-text text-base-content " + labelStyle}>
          {labelTitle}
        </span>
      </label>
      <input
        type={type || "text"}
        name={name}
        value={value}
        placeholder={placeholder || ""}
        onChange={(e) => updateInputValue(e.target.value)}
        autoComplete={autoComplete}
        className="input input-bordered w-full"
      />
    </div>
  );
}

export default InputText;
